<template>
    <div class="content">
        <div class="row">
            <div class="col-md-10 flex-container-top">
                <h2 class="text-eveer">Credits Bundles List</h2>
                <base-button v-if="role == 'Admin'" type="primary" round icon class="top-button"
                    @click="$router.push('add?id=-1')">
                    <i class="fa fa-plus"></i>
                </base-button>
            </div>
        </div>

        <div class="row" v-if="this.tableData.length !== 0">
            <div class="col-12">
                <card card-body-classes="table-full-width">
                    <h4 slot="header" class="card-title">Credits Bundles List</h4>
                    <div>
                        <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                            <el-select class="select-primary mb-3 pagination-select" v-model="pagination.perPage"
                                placeholder="Per page">
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item"
                                    :label="item" :value="item">
                                </el-option>
                            </el-select>
                            <!-- <base-input>
                                <el-input type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search"
                                    placeholder="Search records" v-model="searchQuery" aria-controls="datatables">
                                </el-input>
                            </base-input> -->
                        </div>
                        <el-table :data="queriedData" style="font-size: 13px">
                            <el-table-column :min-width="150" align="left" label="Name">
                                <div slot-scope="props">
                                    <div style="font-weight: 300;">
                                        {{ props.row.name }}
                                    </div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" label="Cost">
                                <div slot-scope="props">
                                    <div style="font-weight: 300;">
                                        {{ props.row.cost }}
                                    </div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" label="No. of Credits">
                                <div slot-scope="props">
                                    <div>{{ props.row.money_count }}</div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" label="Control">
                                <div slot-scope="props">
                                    <i v-if="role == 'Admin'" class="fa fa-edit text-warning icon-padding"
                                        @click="$router.push('edit?id=' + props.row._id)" title="Edit Schedule"
                                        style="cursor: pointer"> </i>
                                    <i v-if="role == 'Admin'" class="fa fa-trash-alt text-danger icon-padding"
                                        @click="deleteCreditsBundle(props.row._id)" title="Delete Schedule"
                                        style="cursor: pointer">
                                    </i>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="">
                            <p class="card-category">
                                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                            </p>
                        </div>
                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="total">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <div class="row loader-pos">
            <div class="sk-chase" v-if="loading">
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
            </div>

            <div class="no-data-message" v-if="noDataMessage">
                <div>There are no records found</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import { Modal, BaseAlert } from "src/components";

export default {
    components: {
        BasePagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Modal,
        BaseAlert,
    },
    computed: {
        queriedData() {
            let result = this.tableData;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.tableData.length;
        },
    },
    data() {
        return {
            role: window.localStorage.getItem("role"),
            noDataMessage: false,
            loading: false,
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 50, 100, 1000],
                total: 0,
            },
            searchQuery: "",
            tableData: [],
            name: "",
            cost: "",
            money_count: "",
            searchedData: [],
            fuseSearch: null,
        };
    },
    async mounted() {
        await this.LoadCreditsbundles();
    },
    watch: {
        searchQuery(value) {
            let result = this.tableData;
            console.log(value);
            console.log(this.searchQuery);
            if (this.searchQuery !== "") {
                result = this.fuseSearch.search(this.searchQuery);
                console.log(result);
                result = result.map(a => a.item);
            }
            this.searchedData = result;
        },
    },
    methods: {
        async compare(a, b) {
            if (a > b) return +1;
            if (a < b) return -1;
            return 0;
        },

        async LoadCreditsbundles() {
            this.loading = true;
            let test = await this.$apiService.getCall("dropintopup/get-dropInTopUp");
            this.role = window.localStorage.getItem("role");
            var role = this.role;

            if (role == "Admin") {
                this.tableData = test.apidata.Data || [];
            }

            this.fuseSearch = new Fuse(this.tableData, {
                keys: ["name"],
                threshold: 0.3,
            });

            this.tableData.sort((a, b) => (this.compare(a.date, b.date) || this.compare(a.start_time, b.start_time)));
            this.loading = false;

            if ((this.tableData || []).length == 0) {
                this.noDataMessage = true;
            }
        },

        async deleteCreditsBundle(id) {
            let confirmed = confirm("Are you sure you want to delete this Credits bundle? ");
            if (confirmed === true) {
                this.loading = true;
                const del_credits_bundle = await this.$apiService.postCall("dropintopup/delete-dropInTopUp/" + id)
                console.log(del_credits_bundle)
                if (del_credits_bundle.apidata.Code !== "P00001") {
                    this.$apiService.notify(del_credits_bundle.apidata.Message + ".");
                } else {
                    this.$apiService.notify("Credits bundle has been deleted.");
                    await this.LoadCreditsbundles();
                }
                this.loading = false;
            }
        },
    },
};
</script>

<style>
.pagination-select,
.search-input {
    width: 200px;
}

.swal2-icon-content {
    font-size: inherit !important;
}

.group-img {
    width: 100%;
    max-width: 100px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
}

.icon-padding {
    padding: 10px;
}
</style>